/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "com.atproto.repo.describeRepo";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"repo":/*#__PURE__*/ l.string({"format":"at-identifier"})});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"did":/*#__PURE__*/ l.string({"format":"did"}),"didDoc":/*#__PURE__*/ l.lexMap(),"handle":/*#__PURE__*/ l.string({"format":"handle"}),"collections":/*#__PURE__*/ l.array(/*#__PURE__*/ l.string({"format":"nsid"}), ),"handleIsCorrect":/*#__PURE__*/ l.boolean()});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Get information about an account and repository, including the list of collections. Does not require auth. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output);

export { main };

export const $lxm = $nsid;
